import BenefitContent from "./BenefitContent";
import { footerMenuList, socialIcons } from "../../data/footer_data";
import Link from "next/link";

const Benefits = () => {
  return (
    <>
      {/* <!-- Benefits --> */}
      <section className="py-24 dark:bg-jacarta-900">
        <div className="container">
          <div className="mx-auto mb-16 max-w-xl text-center">
            <h2 className="mb-6 text-center font-display text-3xl font-medium text-jacarta-700 dark:text-white">
              VS Token
            </h2>
            <p className="text-lg dark:text-jacarta-300">
              Help support VirtueSekai by grabbing our initial offering token!
            </p>
            <br />
             <Link href="/vstoken">
                  <a className="inline-block rounded-full bg-accent py-2.5 px-8 mb-8 text-center text-sm font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark">
                  VS Token
                  </a>
            </Link>
                <div style={{justifyContent: 'center'}} className="flex space-x-5">
                {socialIcons.map((item) => {
                  const { id, href, text } = item;
                  return (
                    <Link href={href} key={id}>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group cursor-pointer"
                      >
                        <svg className="icon group-hover:fill-accent fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white">
                          <use xlinkHref={`/icons.svg#icon-${text}`}></use>
                        </svg>
                      </a>
                    </Link>
                  );
                })}
              </div>

          </div>
          
          <BenefitContent />
        </div>
      </section>
      {/* <!-- end benefits --> */}
    </>
  );
};

export default Benefits;
